import React from 'react'
import PropTypes from 'prop-types'

const TableLoader = ({ limit = 20 }) => {
  const renderRows = () => {
    return Array(limit)
      .fill({})
      .map((v, i) => <div key={i} className="ph-col-12 big py-5"></div>) // to remove react's console.log error
  }

  return (
    <div className="ph-item border-0 bg-white p-0">
      <div className="ph-col-12 px-0">
        <div className="ph-row">{renderRows()} </div>
      </div>
    </div>
  )
}

TableLoader.propTypes = {
  limit: PropTypes.number,
}

export default TableLoader
